import { render, staticRenderFns } from "./sh_TestVideo.vue?vue&type=template&id=33ef1399&scoped=true&"
import script from "./sh_TestVideo.vue?vue&type=script&lang=js&"
export * from "./sh_TestVideo.vue?vue&type=script&lang=js&"
import style0 from "./sh_TestVideo.vue?vue&type=style&index=0&id=33ef1399&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef1399",
  null
  
)

export default component.exports